import update from 'immutability-helper';
import _ from 'lodash';
import type {
  GetChatStreamItems,
  GetChatStreamItems_chatStreams_sequenceItems as ChatStreamSequenceItem,
} from '../queries/__generated__/GetChatStreamItems';
import { putMessage_putMessage_messages_chatMessages as PutMessageSequenceItem } from 'chat/queries/__generated__/putMessage';

export function addSequenceItemsToQueryResult(
  result: GetChatStreamItems,
  newSequenceItems: Array<ChatStreamSequenceItem | PutMessageSequenceItem>
) {
  // make sure this has the minimal required attributes
  // (needed in the case of an empty stream)
  result = _.defaultsDeep(result, {
    chatStreams: [{ sequenceItems: [] }],
  });

  const oldItems = result.chatStreams?.[0]?.sequenceItems || [];
  const newItems = newSequenceItems;

  const sortedArray = [...newItems, ...oldItems].sort((a, b) => {
    if (Number(a.seq) > Number(b.seq)) {
      return -1;
    }

    if (Number(a.seq) < Number(b.seq)) {
      return 1;
    }

    return 0;
  });

  return update(result, {
    chatStreams: {
      '0': { sequenceItems: { $set: _.uniqBy(sortedArray, 'key') } },
    },
  });
}
